export default __webpack_public_path__ + "locales/vi/Payments.json?hash=de921b935150fdd2954eb6a8270e3e86";